import { Relationships } from '@leverege/ui-attributes';
export default Relationships;